import gql from 'graphql-tag';

export const FRAGMENT_BLOG_POST_BUILDER_BRIEF = gql`
  fragment BlogPostBuilderBrief on BlogPostBuilderBrief {
    id
    type
    status
    errors
    name
    language
    description
    keywords
    targetKeywords
    supportingKeywords
    url
    brandVoice {
      id
      name
    }
    tov
    blogLanguage
    promptImageId
    promptDocumentId
    freestyleToolAllInstructionsData
    generationInfo
  }
`;

export const FRAGMENT_PROJECT_BLOG_CONTENT_OUTLINE_SECTION = gql`
  fragment BlogPostBuilderOutlineSection on BlogPostBuilderOutlineSection {
    id
    headline
    content
    paragraphs # can be removed after all sections would be converted to HTML
    order
    keywordsUsage
    manualKeywords
    instructions
    lastPlagiarismCheckResult # currently not used for outlines, leaving here for future use
    generationLength
    textStatus
    subtopic
    details
  }
`;

export const FRAGMENT_PROJECT_BLOG_CONTENT = gql`
  fragment BlogPostBuilderContent on BlogPostBuilderContent {
    id
    title
    titleScore
    introParagraph
    introManualKeywords
    introKeywordsUsage
    introInstructions
    introGenerationLength
    introTextStatus
    lastPlagiarismCheckResult {
      potentialCopiedSentences {
        url
        title
        snippet
        percentMatched
      }
      overallSimilarityPercent
      checksUsed
      lastCheckTime
    }
    outlineSections {
      ...BlogPostBuilderOutlineSection
    }
    generationInfo
  }
  ${FRAGMENT_PROJECT_BLOG_CONTENT_OUTLINE_SECTION}
`;

export const FRAGMENT_BLOG_POST_BUILDER_DRAFT = gql`
  fragment BlogPostBuilderDraft on BlogPostBuilderDraft {
    id
    projectId
    draftId
    status
    name
    generationInfo
    language
    complianceStatus
    complianceProgressPercentage
    complianceError {
      type
      message
    }
  }
`;

export const FRAGMENT_STATS_FACTS_AND_QUOTES_REQUEST = gql`
  fragment StatsFactsAndQuotesFields on StatsFactsAndQuotes {
    text
    type
    resourceType
    name
    url
  }
`;

export const FRAGMENT_STATS_FACTS_AND_QUOTES_RESPONSE = gql`
  fragment StatsFactsAndQuotesResponse on StatsFactsAndQuotesResponse {
    cursor
    statsFactsAndQuotes {
      ...StatsFactsAndQuotesFields
    }
  }
  ${FRAGMENT_STATS_FACTS_AND_QUOTES_REQUEST}
`;

export const FRAGMENT_SUBTOPICS = gql`
  fragment Subtopics on Subtopics {
    cursor
    subtopics {
      subtopic
      details
      name
      url
    }
  }
`;
